export default __webpack_public_path__ + "img/be5c0f53779e16bf1c29f9d44e93ddca.svg";